module.exports = __webpack_public_path__ + "static/banner_vestibular_2025_2_mobile-551dadd17ddd4d2f7c5559d9d74ab5bf.jpg";